<template>
  <form>
    <div class="columns is-multiline">
      <div class="column is-4-desktop is-12-touch">
        <div class="title is-4">Bill to company?</div>

        <div class="field" style="margin-bottom:1.4em">
          <p class="control">
            <label class="radio">
              <input v-model="form.to_company" type="radio" value="1" />
              Yes
            </label>
            <label class="radio">
              <input v-model="form.to_company" type="radio" value="0" />
              No
            </label>
          </p>
          <p v-if="form.errors.has('to_company')" class="help is-danger">
            {{ form.errors.get('to_company') }}
          </p>
        </div>

        <div v-if="form.to_company == 1">
          <div class="field">
            <label class="label">Company Name</label>
            <p class="control">
              <input
                v-model="form.company"
                class="input is-medium"
                :class="form.errors.has('company') ? 'is-danger' : ''"
                placeholder="Company name"
              />
            </p>
            <p v-if="form.errors.has('company')" class="help is-danger">
              {{ form.errors.get('company') }}
            </p>
          </div>

          <div class="field">
            <label class="label">Company Code</label>
            <p class="control">
              <input
                v-model="form.company_code"
                class="input is-medium"
                :class="form.errors.has('company_code') ? 'is-danger' : ''"
                placeholder="Company code"
              />
            </p>
            <p v-if="form.errors.has('company_code')" class="help is-danger">
              {{ form.errors.get('company_code') }}
            </p>
          </div>

          <div class="field">
            <label class="label">VAT</label>
            <p class="control">
              <input
                v-model="form.vat"
                class="input is-medium"
                :class="form.errors.has('vat') ? 'is-danger' : ''"
                placeholder="VAT"
              />
            </p>
            <p v-if="form.errors.has('vat')" class="help is-danger">
              {{ form.errors.get('vat') }}
            </p>
          </div>
        </div>
      </div>
      <div class="column is-4-desktop is-12-touch">
        <div class="title is-4">
          Billing Address
        </div>

        <div class="field">
          <country-select
            v-model="form.country"
            name="country"
            placeholder="Select country..."
            :has-errors="form.errors.has('country')"
            :label="parseInt(form.to_company) ? 'Company Country' : 'Your Country'"
          />
          <p v-if="form.errors.has('country')" class="help is-danger">
            {{ form.errors.get('country') }}
          </p>
        </div>

        <div class="field">
          <label class="label">
            {{ parseInt(form.to_company) ? 'Company' : 'Your' }}
            Region
          </label>
          <p class="control">
            <input
              v-model="form.region"
              class="input is-medium"
              :class="form.errors.has('region') ? 'is-danger' : ''"
              placeholder="Region"
            />
          </p>
          <p class="help">
            Required if country is: United States, Canada or Mexico
          </p>
          <p v-if="form.errors.has('region')" class="help is-danger">
            {{ form.errors.get('region') }}
          </p>
        </div>

        <div class="field">
          <label class="label">
            {{ parseInt(form.to_company) ? 'Company' : 'Your'}}
            City
          </label>
          <p class="control">
            <input
              v-model="form.city"
              class="input is-medium"
              :class="form.errors.has('city') ? 'is-danger' : ''"
              placeholder="City"
            />
          </p>
          <p v-if="form.errors.has('city')" class="help is-danger">
            {{ form.errors.get('city') }}
          </p>
        </div>

        <div class="field">
          <label class="label">
            {{ parseInt(form.to_company) ? 'Company' : 'Your'}}
            Address
          </label>
          <p class="control">
            <input
              v-model="form.address"
              class="input is-medium"
              :class="form.errors.has('address') ? 'is-danger' : ''"
              placeholder="Address"
            />
          </p>
          <p v-if="form.errors.has('address')" class="help is-danger">
            {{ form.errors.get('address') }}
          </p>
        </div>

        <div class="field">
          <label class="label">
            {{ parseInt(form.to_company) ? 'Company' : 'Your'}}
            Zip Code
          </label>
          <p class="control">
            <input
              v-model="form.zip"
              class="input is-medium"
              :class="form.errors.has('zip') ? 'is-danger' : ''"
              placeholder="Zip code"
            />
          </p>
          <p v-if="form.errors.has('zip')" class="help is-danger">
            {{ form.errors.get('zip') }}
          </p>
        </div>
      </div>
      <div class="column is-4-desktop is-12-touch">
        <div class="title is-4">Billing Contact</div>

        <div class="field">
          <label class="label">Person</label>
          <p class="control">
            <input
              v-model="form.person"
              class="input is-medium"
              :class="form.errors.has('person') ? 'is-danger' : ''"
              placeholder="Person"
            />
          </p>
          <p v-if="form.errors.has('person')" class="help is-danger">
            {{ form.errors.get('person') }}
          </p>
        </div>

        <div class="field">
          <label class="label">Email</label>
          <p class="control">
            <input
              v-model="form.email"
              class="input is-medium"
              :class="form.errors.has('email') ? 'is-danger' : ''"
              type="email"
              placeholder="Email"
            />
          </p>
          <p v-if="form.errors.has('email')" class="help is-danger">
            {{ form.errors.get('email') }}
          </p>
        </div>
      </div>
    </div>

    <slot name="footer" :save="save"></slot>
    
    <vue-loading-overlay :active.sync="isLoading" :can-cancel="true" />
  </form>
</template>

<script>
import Form from './../../helpers/Form/Form';
import VueLoadingOverlay from 'vue-loading-overlay';

export default {
  name: 'BillingInformation',
  components: {
    'vue-loading-overlay' : VueLoadingOverlay
  },
  props: {
    action_url: { type: String, required: true },
    redirect_url: { type: String, default: null },
    user: { type: Object, default: null },
    is_company: { type: Number, default: 0 }
  },
  data() {
    return {
      isLoading: false,
      model: this.user,
      form: new Form({
        person: '',
        email: '',
        country: '',
        region: '',
        city: '',
        address: '',
        zip: '',
        to_company: '0',
        company: '',
        company_code: '',
        vat: '',
        redirect: this.redirect_url
      }).dontResetAfterSuccess()
    };
  },

  mounted() {
    if (this.user.billing_information) {
      this.form.assign(this.user.billing_information);
    } else {
      let country = '';
      if (this.is_company && this.user.company_country) {
        country = this.user.company_country;
      } else if (this.user.country) {
        country = this.user.country;
      }
      this.form.assign({
        person: this.user.name ? this.user.name : '',
        email: this.user.email ? this.user.email : '',
        country: country,
        city: this.user.city ? this.user.city : '',
        address: this.user.address ? this.user.address : '',
        zip: this.user.zip ? this.user.zip : '',
        to_company: this.is_company ? '1' : '0',
        company: this.user.company_name && this.is_company ? this.user.company_name : '',
        company_code: this.user.company_code && this.is_company ? this.user.company_code : '',
        vat: this.user.vat_number && this.is_company ? this.user.vat_number : ''
      });
    }
  },

  created() {
    window.reloadOnHistoryBack();
  },

  methods: {
    save() {
      this.isLoading = true;

      this.form.patch(this.action_url)
        .then(data => {
          if (this.redirect_url) {
            location.href = this.redirect_url;
            return;
          }
          this.isLoading = false;
          VueEventHub.$emit('flash', data.success ? data.success : '', 'success');
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
